import { useEffect, useState } from 'react'
import { GetActiveReportingYear } from '../services/peerToPeer/PeerToPeerService'
import { GetP2PDashboard, GetP2PDashboardFilterOrganizations, type P2PFilterOrganization } from '../services/peerToPeer/DashboardService'
import { type DashboardModel } from '../models/peerToPeer/Dashboard'
import { handleApiResponse } from '../utils/apiHelpers'

interface UseP2PDashboardType {
  model: DashboardModel | null
  reportingYearId: number
  filterOrgs: P2PFilterOrganization[]
  isLoading: boolean
}

export const useP2PDashboard = (scopeOrgId: number): UseP2PDashboardType => {
  const [reportingYearId, setReportingYearId] = useState<number>(0)
  const [filterOrgs, setFilterOrgs] = useState<P2PFilterOrganization[]>([])
  const [model, setModel] = useState<DashboardModel | null>(null)
  const [isLoading, setIsLoading] = useState<boolean>(true)

  useEffect(() => {
    const loadReportingYear = async (): Promise<void> => {
      const year = await handleApiResponse(GetActiveReportingYear())
      if (year == null) {
        setIsLoading(false)
        return
      }
      setReportingYearId(year.id)
      setFilterOrgs(await handleApiResponse(GetP2PDashboardFilterOrganizations(year.id)) ?? [])
    }

    void loadReportingYear()
  }, [])

  useEffect(() => {
    if (reportingYearId === 0) return
    let isCurrent = true

    const loadModel = async (): Promise<void> => {
      setIsLoading(true)
      const dashboard = await handleApiResponse(GetP2PDashboard(scopeOrgId, reportingYearId))
      if (!isCurrent) return
      setModel(dashboard)
      setIsLoading(false)
    }

    void loadModel()
    return () => { isCurrent = false }
  }, [scopeOrgId, reportingYearId])

  return { model, reportingYearId, filterOrgs, isLoading }
}
